import React, {useEffect} from "react";
import {getAuth, onAuthStateChanged} from "@firebase/auth";
import {useNavigate, useLocation} from "react-router";

const AuthCheck: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        // List of public paths that don't require authentication
        const publicPaths = ['/', '/auth/response', '/home', '/login', '/support', '/updates'];
        if (!publicPaths.includes(location.pathname)) {
          navigate('/');
        }
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname]);

  return <></>;
};

export default AuthCheck;